import { useAction } from '@shared/lib/redux'

import { toastListStore } from './redux-toast.slice'

export const useRemoveToast = () => {
  const remove = useAction(toastListStore.actions.removeToast)
  return {
    remove
  }
}
export const useCreateToast = () => {
  const create = useAction(toastListStore.actions.addToast)
  return {
    create
  }
}
